import { gql } from "@apollo/client";export default gql`mutation UpdateGroupWorksheetMap($id: Int!, $_set: worksheet_group_worksheet_map_set_input = {}) {
  update_worksheet_group_worksheet_map_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
`;
